<template>
    <div class="flex flex-col gap-2 w-full p-2">
        <template v-for="(item, index) of items" :key="index">
            <ClaimCard :items="item"/>
        </template>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import ClaimCard from './ClaimCard.vue';

export default defineComponent({
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    setup: function () {
    },
    components: { ClaimCard }
})
</script>

